import { bool, func } from 'prop-types';
import React, { useCallback } from 'react';

import ModalComponent from '@components/Share/ModalComponent';
import StoreLocatorFilterPopupContent from '@components/Share/StoreLocator/StoreLocatorContent/StoreLocatorBar/StoreLocatorFilterIcon/StoreLocatorFilterPopupContent';

import useSelectStoreAndDateContext from '../../../useSelectStoreAndDateContext';
import { useCampaignFilterStoreBarContext } from '../index';

const FilterPopup = ({ showFilter, onCloseFilterPopup }) => {
  const { layoutData } = useSelectStoreAndDateContext();
  const { onClearFilterArea, onFilter } = useCampaignFilterStoreBarContext();

  const handleSubmitFilter = useCallback(
    (params) => {
      if (params) {
        if (onFilter) onFilter(params);
      } else {
        if (onClearFilterArea) onClearFilterArea();
      }
      if (onCloseFilterPopup) onCloseFilterPopup();
    },
    [onCloseFilterPopup, onClearFilterArea]
  );

  return (
    <ModalComponent
      isShow={showFilter}
      titlePopup={layoutData?.filterStoresLabel?.value || layoutData?.['Filter Stores Label']?.value}
      onCloseHandler={onCloseFilterPopup}
      cssClass='search-filter-bar__filter-popup'
    >
      <div className='address-component'>
        <StoreLocatorFilterPopupContent dataFields={layoutData} setSubmitAddressEvt={handleSubmitFilter} />
      </div>
    </ModalComponent>
  );
};

FilterPopup.propTypes = {
  showFilter: bool,
  onCloseFilterPopup: func
};

export default FilterPopup;
